import type { SideSheetBodyProps } from "./types";

export function SideSheetBody({
  children,
  className = "",
}: SideSheetBodyProps) {
  return (
    <div
      className={`flex-1 overflow-y-auto px-6 pt-2 scrollbar-thin ${className}`}
    >
      {children}
    </div>
  );
}
